import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/easm-settings/create/')({
  beforeLoad: ({ context, preload }) => {
    const {
      // userPermissions: { hasAllowedPermissionToResource },
      validatePermissions,
    } = context;
    // todo: before removing feature-flag: update isAllowed in validatePermissions functions to actual value
    // const isAllowed = hasAllowedPermissionToResource({ resource: PermissionEntitiesNames.EASM_CONFIGURATION, permission: Permission.READ });
    validatePermissions({ isAllowed: true, preload });
  },
});
